/* eslint-disable prettier/prettier */
/* eslint-disable no-empty */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
const btnOpenModal = document.querySelector("#openModalSubscription");
const modalNsl = document.querySelector("#welcomeModal");
const btnCloseModal = document.querySelector(".nsl-close");

const form = document.querySelector("#nslFormSubscription");
const btnSubmit = document.querySelector("#nslSubscription-send");
const loader = document.querySelector(".nslWaitloader");
const result_block = document.querySelector(".response");

export default class NslSubscription {
  /*static openModal = function () {
    if (!localStorage.getItem("welcomeModalShown")) {
      setTimeout(() => {
        if (!modalNsl) return;
        modalNsl.classList.add("open");
        document.documentElement.style.overflow = "hidden";

        localStorage.setItem("welcomeModalShown", "true");
      }, 10000);
    }
  };*/

  static closeModal = function () {
    btnCloseModal.addEventListener("click", function () {
      modalNsl.classList.remove("open");
      document.documentElement.style.overflow = "";
    });
  };

  static manualModal = function () {
    btnOpenModal.addEventListener("click", function () {
      modalNsl.classList.add("open");
      document.documentElement.style.overflow = "hidden";
    });
  };

  static validate = function () {
    form.addEventListener(
      "submit",
      function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
          form.classList.add("was-validated");
          let list = form.querySelectorAll(":invalid");
          for (var item of list) {
            if (item.id == "nsl-privacy") {
              // eslint-disable-next-line prettier/prettier
              item.classList.add("is-invalid");
            }
          }
        } else {
          const formData = new FormData(form);
        }
        //
        //const formData = new FormData(form);
      },
      false
    );

    form.addEventListener("formdata", (e) => {
      const wait = document.querySelector(".wait");
      const hiddenFields = form.querySelectorAll(".nsl-form-name, .nsl-form-mail, .form-group.prv, .help-block, .flex");
      hiddenFields.forEach((el) => (el.style.display = "none"));
      wait.style.display = "flex";
      loader.style.display = "block";

      const resetForm = function () {
        hiddenFields.forEach((el) => (el.style.display = ""));
        form.classList.remove("was-validated");
        form.reset();
      };

      // modifies the form data
      const formData = e.formData;
      const gtmNewsletterSubscription = form.dataset.gtmEventNewsletterSubscription;

      //se utilizzeremo anche il nome e cognome
      //+ '&ocsvFldNames=campo1&csvFldValues='+ encodeURIComponent( formData.get("campo1") )

      let dati = "list=" + encodeURIComponent(formData.get("list")) + "&group=" + encodeURIComponent(formData.get("group")) + "&email=" + encodeURIComponent(formData.get("email")) + "&ocsvFldNames=campo1&csvFldValues=" + encodeURIComponent(formData.get("name")) + "&confirm=true";
      //console.log(dati);

      fetch("https://a1e0h.mailupclient.com/frontend/subscribe.aspx", {
        method: "POST",
        body: dati,
        headers: {
          "Content-type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (response) {
          if (response.ok) {
            return response;
          } else {
            return Promise.reject(response);
          }
        })
        .then(function (data) {
          //console.log(data);
          console.log(gtmNewsletterSubscription);
          loader.style.display = "none";
          if (data.status === 200) {
            //datalayer event GTM
            if (typeof gtmNewsletterSubscription !== "undefined") {
              let event = { event: gtmNewsletterSubscription };
              console.log(event);
              try {
                event = JSON.parse(gtmNewsletterSubscription);
              } catch (error) {} // eslint-disable no-empty
              dataLayer.push(event);
            }
          }
          setTimeout(function () {
            result_block.style.display = "block";
            setTimeout(function () {
              result_block.style.display = "none";
              wait.style.display = "none";
              modalNsl.classList.remove("open");
              document.documentElement.style.overflow = "";
              resetForm();
            }, 2000);
          }, 300);
        })
        .catch(function (error) {
          console.warn("Something went wrong.", error);
          loader.style.display = "none";
          wait.style.display = "none";
          resetForm();
        });
    });
  };

  static init() {
    //NslSubscription.openModal();
    NslSubscription.closeModal();
    NslSubscription.validate();
    NslSubscription.manualModal();
  }
}
